import qs from 'qs';
import request from '../utils/request';

// 快递员扣费记录
export const partnerDeduct = (param) => request(`/admin/financial/deduct?${qs.stringify(param)}`);
// 快递员充值记录
export const partnerRecharge = (param) => request(`/admin/financial/recharge?${qs.stringify(param)}`);
// 超时费用
export const overTimePay = (param) => request(`/admin/financial/over-time-pay?${qs.stringify(param)}`);
// 退款
export const refund = (id, reason) => request({
  url: `/admin/financial/refund/${id}`,
  method: 'PUT',
  data: { reason },
});
